import { GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { standardOperators } from '../../Compounds/UpstackDataGrid/helpers';
import { ENGAGEMENT_STATUS_LABELS, engagementStatusLabel } from '../../../constants/advise';

export const EngagementsPageGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'engagement_name',
    headerName: 'Engagement',
    sortable: true,
    width: 250,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'product_type',
    headerName: 'Product Type',
    sortable: true,
    width: 130,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: true,
    width: 150,
    filterable: true,
    type: 'singleSelect',
    valueOptions: Object.entries(ENGAGEMENT_STATUS_LABELS).map(([value, label]) => ({ value, label })),
    valueFormatter: (value: string) => engagementStatusLabel(value),
    description: 'Drag to move column'
  },
  {
    field: 'selected_suppliers',
    headerName: 'Suppliers',
    sortable: true,
    width: 100,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    valueFormatter: (value: string[]) => (Array.isArray(value) ? `${value.length}` : '0'),
    description: 'Drag to move column'
  },
  {
    field: 'owner_name',
    headerName: 'Owner',
    sortable: true,
    width: 160,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'created_date',
    headerName: 'Created',
    sortable: true,
    width: 120,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    valueFormatter: (value: string) => (value ? new Date(value).toLocaleDateString() : ''),
    description: 'Drag to move column'
  }
];
